import { Button, Card, CardActions, CardContent, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { Component } from "react";
import PopinaRestaurant from "../../controller/model/popina/PopinaRestaurant";
import { PopinaItemInterface } from "../../controller/model/popina/interface";
import Environment from "../../utils/Environement";
import { shortenUUID } from "../../utils/formater";

interface PropsInterface {
  restaurant: PopinaRestaurant;
}

interface StateInferface {
  item: PopinaItemInterface;
  open: boolean;
  showMo: boolean;
}

class ItemDetailComponent extends Component {
  public props: PropsInterface;
  public state: StateInferface;

  constructor(props: any) {
    super(props);
    this.state = {
      open: false,
      showMo: false,
      item: {} as PopinaItemInterface,
    };
    this.props = props;
  }

  showModal = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  handleModal = (oldItem: any) => {
    if (oldItem) {
      this.setState({
        item: oldItem,
      });
    }
    this.setState({
      open: !this.state.open,
    });
  };

  render() {
    return (
      <div key={this.state.item.client_id}>
        <Dialog
          maxWidth="sm"
          onClose={() => {
            this.showModal();
          }}
          aria-labelledby="customized-dialog-title"
          open={this.state.open}
          fullWidth={true}
        >
          <DialogTitle
            id="customized-dialog-title"
            style={{ backgroundColor: "#474F5E", color: "white" }}
          >
            Détail du produit :
          </DialogTitle>

          <DialogContent dividers>
            <div style={{ border: (Environment.isPopina) ? "1px solid #7ABF92" : "1px solid #ffd400", padding: "20px" }}>
              <span
                style={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  color: "#474F5E",
                }}
              >
                {" "}
                {this.state.item.name}{" "}
              </span>
              <hr style={{ borderColor: (Environment.isPopina) ? "#7ABF92" : "#ffd400" }} />
              <div style={{display:"flex", padding: "10px 0" }}>
                <p style={{ color: "#474F5E", margin:0, marginRight:"4px"}}>
                  Identifiant:
                </p>
                <p style={{ color: "#33499ac2", margin:0, fontWeight:"bold"}}>
                  {shortenUUID(this.state?.item?.client_id)}
                </p>
              </div>
              
              <div style={{padding: "10px 0"}}>
              <p style={{ color: "#474F5E", margin:0 }}>Option spéciale : </p>
              {this.state.item.optionCategories === undefined || null
                ? "option vide"
                : Object.values(this.state.item.optionCategories).map(
                  (value: string) => {
                    const groupeOption = this.props.restaurant.getOptionGroupe(
                      value,
                      "option_categories"
                    );

                    return groupeOption !== undefined ? (
                      <div
                        key={groupeOption.client_id}
                        style={{ width: "20%", marginRight: "10px" }}
                      >
                        <h3
                          style={{
                            textAlign: "center",
                            color: "#33499ac2",
                          }}
                        >
                          {groupeOption.name}
                        </h3>

                        {groupeOption.options.map((option) => {
                          return (
                            <Card
                              key={option.client_id}
                              style={{ border: (Environment.isPopina) ? "1px solid #7ABF92" : "1px solid #ffd400" }}
                            >
                              <CardContent
                                style={{
                                  borderBottom: (Environment.isPopina) ? "1px solid #7ABF92" : "1px solid #ffd400",
                                  textAlign: "center",
                                }}
                              >
                                <Typography
                                  color="primary"
                                  gutterBottom
                                  style={{
                                    textAlign: "center",
                                    textTransform: "capitalize",
                                  }}
                                >
                                  {option.name}
                                </Typography>
                              </CardContent>
                              <CardActions
                                style={{
                                  backgroundColor: "#F1F1F5",
                                  color: "#474F5E",
                                  textAlign: "center",
                                }}
                              >
                                {option.price} €
                                </CardActions>
                            </Card>
                          );
                        })}
                      </div>
                    ) : (
                        <div></div>
                      );
                  }
                )}
              </div>

              <div style={{padding: "10px 0"}}>
              <p style={{ color: "#474F5E", margin:0 }}>Option Partagée : </p>
              <div style={{ display: "flex", padding:"12px 0" }}>
                {!this.state.item.sharedOptionCategories
                  ? "oui"
                  : Object.values(this.state.item.sharedOptionCategories).map(
                    (value: string) => {
                      const groupeOption = this.props.restaurant.getOptionGroupe(
                        value,
                        "shared_option_categories"
                      );
                      return groupeOption !== undefined ? (
                        <div
                          key={groupeOption.client_id}
                          style={{ width: "20%", marginRight: "10px" }}
                        >
                          <h3
                            style={{
                              textAlign: "center",
                              color: "#33499ac2",
                              margin:0,
                              marginBottom:"10px"
                            }}
                          >
                            {groupeOption.name}
                          </h3>

                          {groupeOption.options.map((option) => {
                            return (
                              <Card
                                key={option.client_id}
                                style={{ marginBottom:"10px", border: (Environment.isPopina) ? "1px solid #7ABF92" : "1px solid #ffd400" }}
                              >
                                <CardContent
                                  style={{
                                    borderBottom: (Environment.isPopina) ? "1px solid #7ABF92" : "1px solid #ffd400",
                                    textAlign: "center",
                                  }}
                                >
                                  <Typography
                                    color="primary"
                                    gutterBottom
                                    style={{
                                      textAlign: "center",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    {option.name}
                                  </Typography>
                                </CardContent>
                                <CardActions
                                  style={{
                                    backgroundColor: "#F1F1F5",
                                    color: "#474F5E",
                                    textAlign: "center",
                                  }}
                                >
                                  {option.price} €
                                  </CardActions>
                              </Card>
                            );
                          })}
                        </div>
                      ) : (
                          <div></div>
                        );
                    }
                  )}
              </div>
              </div>      
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                this.showModal();
              }}
              style={{ color: "white" }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default ItemDetailComponent;
